import { requestForToken } from 'init-firebase';
import { apiPatch, apiPut } from 'services/api';
import { sendAmplitudeData } from './amplitude';

export function copyProps(props, src) {
  return (
    src &&
    (props || []).reduce((dest, prop) => ({ ...dest, [prop]: src[prop] }), {})
  );
}

export async function waitFor(valueFunction, options) {
  const defaultOptions = { timeout: 5000, delay: 100 };
  const { timeout, delay, defaultValue } = { ...defaultOptions, ...options };
  return new Promise((resolve, reject) => {
    const check = (timeout) => {
      const value = valueFunction();
      if (value) {
        return resolve(value);
      }
      if (timeout > 0) {
        return setTimeout(check, delay, timeout - delay);
      }
      typeof defaultValue === 'undefined' ? reject() : resolve(defaultValue);
    };
    check(timeout);
  });
}

export const clickToPrint = (url) => {
  let newIframe = document.createElement('iframe');
  newIframe.width = '0';
  newIframe.height = '0';
  document.body.appendChild(newIframe);
  fetch(url)
    .then((response) => {
      return response.blob();
    })
    .then((myBlob) => {
      var objectURL = URL.createObjectURL(myBlob);
      newIframe.src = '';
      newIframe.src = objectURL;
      objectURL = URL.revokeObjectURL(myBlob);
    })
    .then(() => {
      window.setTimeout(function () {
        newIframe.contentWindow.focus();
        newIframe.contentWindow.print();
      }, 200);
    });
  return;
};

export const preventDefaultHandlers = (handlers) => {
  const newHandlers = {};
  for (const [action, handler] of Object.entries(handlers)) {
    newHandlers[action] = (event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      handler();
      return false;
    };
  }
  return newHandlers;
};

export const registerFCMToken = async (user) => {
  const userId = user.data.id;
  const { token } = await requestForToken();
  apiPut(`/user/${userId}`, {
    body: {
      webFcmToken: token,
    },
  })
    .then((data) => {
      sendAmplitudeData('FCM token sent to server', {
        data: data,
      });
    })
    .catch((err) => {
      sendAmplitudeData('FCM token server registration failed', {
        error: err,
      });
    });
};
